import React from 'react';

/** Question text for cards and detail views — always left-aligned prose. */
const FormattedQuestions = ({ item, className = '', style }) => {
  const text = item?.question ?? '';
  return (
    <span
      className={`learning-question-text${className ? ` ${className}` : ''}`}
      style={style}
    >
      {text}
    </span>
  );
};

export default FormattedQuestions;
